/*
 * @Author: sunwang
 * @Date: 2020-08-03 13:33:53
 */
import router from './router';
import store from './store';
import { duraction, inspectUa } from '_util/login';
import { getSource } from '_util/index';
// const whiteList = ['/404', '/paySuccess']; // 不重定向白名单
import { Toast } from 'vant';

let datePath = {};
let isApp = PLUGIN.isApp;

router.beforeEach(async (to, form, next) => {
  //设置页面title
  if (to.path === '/payment' && to.meta.alias) {
    document.title = to.meta.alias;
  } else {
    document.title = '友米商城';
  }
  let isLogin = PLUGIN.getUserInfo();
  store.commit('SET_IS_LOGIN', !!isLogin);
  inspectUa();
  //???
  getSource();

  duraction(to, form, datePath);
  window.FT_REPORT.setExtendParam('group', to.meta.alias);
  window.FT_REPORT.reportPV();
  if (isApp) {
    await store.dispatch('login');
    let isLogin = PLUGIN.getUserInfo();
    if (to.meta.role && !isLogin) {
      sessionStorage.removeItem('isAppLogin');
      PLUGIN.delUserInfo();
      Toast('请登录后查看');
      next({
        path: '/home'
      });
    } else {
      next();
    }
  } else {
    if (isLogin) {
      // console.log(3333, store.dispatch('login'));
      store.dispatch('login');
      next();
    } else {
      store.commit('SET_IS_LOGIN', false);
      sessionStorage.setItem('uid', '');
      PLUGIN.delUserInfo();
      if (to.meta.role) {
        Toast('请登录后查看');
        next({
          path: '/home'
        });
      } else {
        next();
      }
    }
  }
});



// WEBPACK FOOTER //
// src/perrmision.js